import type { FilterSchema } from '@/shared/components/filter/validation'

import { prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { useAssortmentListQuery } from '@/entities/assortment'

import { Skeleton } from '@/shared/components/ui/skeleton'
import { cn } from '@/shared/lib/utils'
import { formatNumber } from '@/shared/tools/locale'

import { Widget, WidgetContent, WidgetHeader } from '../../Widget'

export default function NumericItemsIntegratedWidget({
	className,
	commonFilters,
}: {
	className?: string
	commonFilters: FilterSchema[]
}) {
	const { t } = useTranslation()

	const { data: totalSkus, isLoading } = useAssortmentListQuery(
		{
			limit: 1,
			filters: commonFilters || [],
		},
		{
			select: prop('total_skus'),
		}
	)

	return (
		<Widget className={cn('relative flex flex-auto flex-col', className)}>
			<WidgetHeader
				title={t('widget.items_integrated.title')}
				tooltip={t('widget.items_integrated.tooltip')}
				subtitle={t('app.based_on_last_integration')}
			/>
			<WidgetContent className='truncate'>
				<div className='mt-auto w-full'>
					{isLoading ? (
						<Skeleton className='col-span-2 h-10 w-32' />
					) : (
						<span className='text-3xl font-semibold'>
							{formatNumber(totalSkus ?? 0)}
						</span>
					)}
				</div>
			</WidgetContent>
		</Widget>
	)
}
